import _ from "lodash"
import {action, observable} from "mobx"
import moment from "moment"
import LineItem from "sdk/LineItem"
import shop from "shop/shop"
import exportCSV from "util/exportCSV"


class QuickorderStore {

	@observable positions = []
	@observable positionById = new Map()
	@observable positionByArticleId = new Map()

	@observable sum = 0
	@observable productCount = 0
	@observable positionCount = 0

	@action
	async setPosition( index, articleNumber ) {
		let lineItem = this.positions[index]
		let dirty = lineItem.dirty

		let sameArticle = this.positionByArticleId.get( articleNumber )
		if ( sameArticle && sameArticle.index !== index ) {
			console.info( "ALREADY IN CART" )
			shop.toast( translate( "Artikel bereits in der Liste vorhanden", "warn" ) )
			return
		}
		let product = await lineItem.fetchProduct( articleNumber )
			.catch( () => {
			} )

		if ( product ) {
			lineItem.index = index
			this.positionById.set( product.map_id, lineItem )
			this.positionByArticleId.set( articleNumber, lineItem )
		}

		if ( !dirty ) {
			this.checkDirty()
		}

	}


	toCart = () => {
		this.positions
			.filter( p => p.product )
			.map( pos => {
				return pos.product
			} )
			.forEach( product => {
				shop.cart.add( product )
			} )
	}


	export = () => {
		const headers = {
			article_nr: "Artikel Nummer",
			count     : "Anzahl",
			desc      : "Beschreibung (optional)"
		}

		const itemsFormatted = this.positions
			.filter( p => p.product )
			.map( pos => {
				return {
					article_nr: pos.product.article_nr,
					count     : pos.product.count,
					desc      : pos.product.desc.des.split( "," ).join( " " )
				}
			} )

		console.log( "EXPORT", {itemsFormatted} )
		const filename = `orderlist-${process.env.REACT_APP_ID}-${moment().format( "YYYY-MM-DD--HH-mm" )}`
		exportCSV( headers, itemsFormatted, filename ); // call the exportCSVFile() function to process the JSON and trigger the download
	}


	@action
	calculate() {
		let sum = 0
		let productCount = 0
		let positionCount = 0
		let productById = new Map()
		let openWarnings = 0

		this.positions.forEach( position => {
			let product = position.product
			if ( product ) {
				product.createWarnings()
				if ( product.warnings ) openWarnings++
				let p = productById.get( product.map_id )
				productCount += product.count
				if ( !p ) {
					positionCount++
				}
				sum += product.count * product.unit_multi * product.price
			}
		} )

		this.sum = sum
		this.productCount = productCount
		this.positionCount = positionCount
	}

	@action
	checkDirty() {
		let allDirty = this.positions.reduce( ( acc, lineItem ) => acc && lineItem.dirty, true )
		console.log( {allDirty} )
		if ( allDirty ) {
			this.positions.push( new LineItem() )
		}
	}

	@action
	remove( index ) {
		this.positions = this.positions.filter( ( item, i ) => {
			let hit = i === index
			if ( hit ) {
				this.positionById.delete( item.product.map_id )
				this.positionByArticleId.delete( item.articleNumber )
			}
			return !hit
		} )
		this.checkDirty()
		this.calculate()
	}

	constructor() {
		// this.positions.push( new LineItem( "D-0100HIVE475-22", 1 ) )
		// this.positions.push( new LineItem( "MOV-A-19063-161", 1 ) )
		this.positions.push( new LineItem() )
	}

	debouncedCalculate = _.debounce( this.calculate, 600, {trailing: true, leading: true} )
}

const quickorderStore = new QuickorderStore()

export default quickorderStore
window.quickorderStore = quickorderStore


// WEBPACK FOOTER //
// ./src/stores/quickorderStore.js